import React, { useState } from 'react';
import { motion } from 'framer-motion';

const hexToRgba = (hex, alpha) => {
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const SkillsSection = () => {
  const [hoveredGroup, setHoveredGroup] = useState(null);

  const groups = [
    {
      title: 'Languages & Frameworks',
      color: '#16a34a',
      skills: ['JavaScript', 'React', 'TypeScript', 'Python', 'Node.js', 'HTML/CSS'],
    },
    {
      title: 'Data & APIs',
      color: '#0ea5e9',
      skills: ['REST APIs', 'SQL', 'MongoDB', 'JSON/XML', 'Postman', 'Supabase'],
    },
    {
      title: 'Support & Ops',
      color: '#a855f7',
      skills: ['Incident Response', 'Root-Cause Analysis', 'Customer Communication', 'Technical Documentation', 'Escalation Management', 'SLA Tracking'],
    },
    {
      title: 'Tools & Platforms',
      color: '#f59e0b',
      skills: ['Git', 'Jira', 'Zendesk', 'Vercel', 'Vite', 'Stripe'],
    },
  ];

  const styles = {
    section: {
      paddingTop: '4rem',
      paddingBottom: '4rem',
      backgroundColor: '#0f0f0f',
      color: '#ffffff',
    },
    container: {
      maxWidth: '1000px',
      margin: '0 auto',
      paddingLeft: '1.5rem',
      paddingRight: '1.5rem',
    },
    heading: {
      fontSize: '2.25rem',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: '3rem',
      color: '#ffffff',
    },
    grid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(2, 1fr)',
      gap: '1.5rem',
    },
  };

  return (
    <section id="skills-section" style={styles.section}>
      <div style={styles.container}>
        <motion.h2
          style={styles.heading}
          initial={{ opacity: 0, y: -20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          Skills & Expertise
        </motion.h2>
        <div style={styles.grid}>
          {groups.map((group, idx) => (
            <motion.div
              key={idx}
              style={{
                backgroundColor: '#1a1a1a',
                padding: '1.5rem',
                borderRadius: '0.75rem',
                border: `1px solid ${hoveredGroup === idx ? hexToRgba(group.color, 0.5) : hexToRgba(group.color, 0.15)}`,
                transition: 'border-color 0.3s ease',
              }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              viewport={{ once: true }}
              onMouseEnter={() => setHoveredGroup(idx)}
              onMouseLeave={() => setHoveredGroup(null)}
            >
              <h3
                style={{
                  fontSize: '1.1rem',
                  fontWeight: 'bold',
                  marginBottom: '1rem',
                  color: group.color,
                }}
              >
                {group.title}
              </h3>
              <div style={{ display: 'flex', flexWrap: 'wrap', gap: '0.5rem' }}>
                {group.skills.map((skill, sIdx) => (
                  <span
                    key={sIdx}
                    style={{
                      padding: '0.4rem 0.85rem',
                      fontSize: '0.875rem',
                      fontWeight: '500',
                      borderRadius: '0.5rem',
                      backgroundColor: hexToRgba(group.color, 0.12),
                      color: group.color,
                      border: `1px solid ${hexToRgba(group.color, 0.25)}`,
                    }}
                  >
                    {skill}
                  </span>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
